<template>
    <div class="home_box">
        <c-head :headShow="headShow" />
        <div class="home_middle_box">
            <router-view />
        </div>
        <c-foot />
    </div>
    <!-- <div
        id="index"
        ref="appRef"
    >
        hello world
    </div> -->
</template>

<script>
import { getLoginApi } from "@/api/index";   //测试
import CHead from '../components/CHead.vue';
import CFoot from '../components/CFoot.vue';
export default {
    mixins: [],
    components: {
        CHead,
        CFoot
    },
    data() {
        return {
            headShow: false
        };
    },
    created() {
        // this.getExamYearNewApi(); //获取年度数据--时间下拉
    },
    mounted() {

    },
    methods: {
        // 获取年度数据--时间下拉
        getExamYearNewApi() {
            getLoginApi({
                r: Math.random()
            }).then((res) => {
                console.log(res);
            }).catch((err) => {
                console.log(err);
            })
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';
</style>

<style lang="scss">
// $cTopHeightUserHeight: 147px;
// $cTopHeightTabHeight: 81px;
// $footBoxHeight: 254px;

// .home_middle_box {
//     min-height: calc(100vh - $cTopHeightTabHeight - $cTopHeightUserHeight - $footBoxHeight );
// }
.home_middle_box {
    min-height: calc(100vh - 81px - 147px - 254px);
}
</style>